/* Productpagina. Progressieve verbetering: zonder dit bestand werkt alles nog.
   De varianten zijn echte radio's binnen het formulier, de miniaturen zijn
   links naar het volledige beeld en de uitklappers zijn details-elementen.
   Dit script maakt er alleen een vloeiender geheel van. */

(function () {
  'use strict';

  function galerij(wortel) {
    wortel.querySelectorAll('[data-galerij]').forEach(function (g) {
      var hoofd = g.querySelector('.pdp__beeld');
      var vergroot = g.querySelector('[data-vergroot]');
      if (!hoofd) return;

      var miniaturen = [].slice.call(g.querySelectorAll('[data-miniatuur]'));

      function toon(mini) {
        var bron = mini && mini.dataset.miniatuur;
        if (!bron) return;
        hoofd.src = bron;
        // srcset zou het nieuwe beeld meteen weer overschrijven.
        hoofd.removeAttribute('srcset');
        if (vergroot) vergroot.setAttribute('href', mini.href);
        miniaturen.forEach(function (m) { m.classList.toggle('is-actief', m === mini); });
        // De strook meeschuiven, anders staat de actieve miniatuur buiten beeld.
        if (mini.scrollIntoView) mini.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }

      miniaturen.forEach(function (mini) {
        mini.addEventListener('click', function (e) {
          e.preventDefault();
          toon(mini);
        });
      });

      /* Bladeren op de grote foto zelf.

         De miniaturen werkten al, maar dat is mikken op een vakje van 70 px —
         en op een telefoon zijn het stipjes van een paar pixels. Wie door de
         foto's wil, wil dat op de foto doen. Vandaar pijlen erover en vegen op
         aanraking, allebei via dezelfde toon(): de miniaturen blijven de ene
         plek waar staat welk beeld actief is, dus een variantwissel en een veeg
         kunnen nooit uiteenlopen.

         Alleen als er iets te bladeren valt. Bij één foto zou een pijl een
         knop zijn die niets doet. */
      if (miniaturen.length > 1) {
        var beeldvlak = hoofd.closest('.pdp__hoofdbeeld') || hoofd.parentNode;
        if (beeldvlak && !beeldvlak.dataset.bladeren) {
          beeldvlak.dataset.bladeren = 'ja';

          var teksten = window.ncStrings || {};

          function huidige() {
            for (var i = 0; i < miniaturen.length; i++) {
              if (miniaturen[i].classList.contains('is-actief')) return i;
            }
            return 0;
          }

          function verschuif(richting) {
            var n = (huidige() + richting + miniaturen.length) % miniaturen.length;
            toon(miniaturen[n]);
          }

          function knop(kant, teken, label) {
            var k = document.createElement('button');
            k.type = 'button';
            k.className = 'pdp__blader pdp__blader--' + kant;
            k.setAttribute('aria-label', label);
            k.textContent = teken;
            k.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              verschuif(kant === 'terug' ? -1 : 1);
            });
            beeldvlak.appendChild(k);
          }

          knop('terug', '←', teksten.previous || 'Vorige');
          knop('verder', '→', teksten.next || 'Volgende');

          /* Vegen. Alleen een duidelijke horizontale beweging telt: anders
             blijft de pagina niet meer verticaal scrollbaar op de foto. */
          var startX = null;
          var startY = null;
          beeldvlak.addEventListener('touchstart', function (e) {
            if (e.touches.length !== 1) return;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
          }, { passive: true });

          beeldvlak.addEventListener('touchend', function (e) {
            if (startX === null) return;
            var raak = e.changedTouches[0];
            var dx = raak.clientX - startX;
            var dy = raak.clientY - startY;
            startX = null;
            startY = null;
            if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
            verschuif(dx < 0 ? 1 : -1);
          }, { passive: true });
        }
      }
    });
  }

  function varianten(wortel) {
    wortel.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var keuzes = form.querySelectorAll('[data-variant-keuze]');
      if (!keuzes.length) return;

      var idVeld = form.querySelector('[data-variant-id]');
      var knop = form.querySelector('[data-add-to-cart]');
      var knoptekst = form.querySelector('[data-knoptekst]');
      var wortelBlok = form.closest('.pdp__koop') || document;
      var prijs = wortelBlok.querySelector('[data-prijs]');
      var prijsWas = wortelBlok.querySelector('[data-prijs-was]');
      var prijsEenheid = wortelBlok.querySelector('[data-prijs-eenheid]');
      var sku = wortelBlok.querySelector('[data-sku]');
      var gekozen = form.querySelector('[data-gekozen]');
      var hoofd = document.querySelector('.pdp__beeld');
      var teksten = window.ncStrings || {};

      keuzes.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;

          if (idVeld) idVeld.value = radio.value;

          form.querySelectorAll('.pdp__variant').forEach(function (rij) {
            rij.classList.toggle('is-gekozen', rij.contains(radio));
          });

          var naam = radio.closest('.pdp__variant').querySelector('.pdp__variant-naam');
          if (gekozen && naam) gekozen.textContent = naam.textContent.trim();
          if (prijs) prijs.textContent = radio.dataset.prijsTekst || prijs.textContent;

          /* Leeg betekent: deze variant heeft geen vergelijkprijs of geen prijs
             per eenheid. Dan het element verbergen in plaats van de waarde van
             de vórige variant laten staan. */
          [[prijsWas, radio.dataset.wasTekst], [prijsEenheid, radio.dataset.eenheidTekst]].forEach(function (paar) {
            var el = paar[0], tekst = paar[1];
            if (!el) return;
            el.textContent = tekst || '';
            el.hidden = !tekst;
          });

          if (sku) {
            var nieuw = radio.dataset.skuTekst;
            sku.hidden = !nieuw;
            if (nieuw) {
              var label = (teksten.sku || 'Artikelnr.');
              sku.textContent = label + ' ' + nieuw;
            }
          }

          var beeld = radio.dataset.beeld;
          if (hoofd && beeld) {
            hoofd.src = beeld;
            hoofd.removeAttribute('srcset');
            document.querySelectorAll('[data-miniatuur]').forEach(function (m) {
              m.classList.remove('is-actief');
            });
          }

          var beschikbaar = radio.dataset.beschikbaar === 'ja';
          if (knop) knop.disabled = !beschikbaar;
          if (knoptekst) {
            knoptekst.textContent = beschikbaar
              ? (teksten.addToCart || 'In winkelwagen') + ' — ' + (radio.dataset.prijsTekst || '')
              : (teksten.soldOut || 'Uitverkocht');
          }
        });
      });
    });
  }

  function aantal(wortel) {
    wortel.querySelectorAll('[data-aantal]').forEach(function (knop) {
      knop.addEventListener('click', function () {
        var veld = knop.parentElement.querySelector('input[name="quantity"]');
        if (!veld) return;
        var stap = parseInt(knop.dataset.aantal, 10) || 0;
        var nu = parseInt(veld.value, 10) || 1;
        var min = parseInt(veld.min, 10) || 1;
        veld.value = Math.max(min, nu + stap);
        veld.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* De aanbevelingen kent Shopify pas ná de eerste render. De sectie wordt
     daarom leeg meegestuurd en hier bijgevuld. Mislukt het, dan blijft het blok
     leeg — beter dan een halve rij of een foutmelding. */
  function aanbevelingen(wortel) {
    wortel.querySelectorAll('[data-aanbevolen][data-url]').forEach(function (blok) {
      if (blok.dataset.gehaald === 'ja') return;
      blok.dataset.gehaald = 'ja';

      fetch(blok.dataset.url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (tekst) {
          var doc = new DOMParser().parseFromString(tekst, 'text/html');
          var nieuw = doc.querySelector('[data-aanbevolen]');
          if (nieuw && nieuw.innerHTML.trim()) {
            blok.innerHTML = nieuw.innerHTML;
            init(blok);
          }
        })
        .catch(function () { /* stil: het blok blijft leeg */ });
    });
  }

  /* Het volle beeld in een laag over de pagina. De knop blijft een gewone link
     naar de afbeelding; hier vangen we de klik af zodat je de productpagina
     niet verlaat. Escape en een klik naast het beeld sluiten hem weer. */
  function lichtbak(wortel) {
    var knoppen = wortel.querySelectorAll('[data-vergroot]');
    if (!knoppen.length) return;

    var laag = document.querySelector('[data-lichtbak]');
    if (!laag) {
      laag = document.createElement('div');
      laag.className = 'lichtbak';
      laag.setAttribute('data-lichtbak', '');
      laag.hidden = true;
      laag.innerHTML = '<img class="lichtbak__beeld" alt="">' +
        '<button class="lichtbak__sluit" type="button" aria-label="' +
        ((window.ncStrings || {}).close || 'Sluiten') + '">&#10005;</button>';
      document.body.appendChild(laag);
    }

    var beeld = laag.querySelector('.lichtbak__beeld');
    var terug = null;

    function sluit() {
      laag.hidden = true;
      document.documentElement.style.overflow = '';
      if (terug) terug.focus();
    }

    laag.addEventListener('click', function (e) {
      if (e.target === laag || e.target.closest('.lichtbak__sluit')) sluit();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !laag.hidden) sluit();
    });

    knoppen.forEach(function (knop) {
      if (knop.dataset.klaar === 'ja') return;
      knop.dataset.klaar = 'ja';
      knop.addEventListener('click', function (e) {
        e.preventDefault();
        terug = knop;
        var hoofd = document.querySelector('.pdp__beeld');
        // Het beeld kan intussen gewisseld zijn door een miniatuur of variant.
        beeld.src = knop.getAttribute('href');
        beeld.alt = hoofd ? hoofd.alt : '';
        laag.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        laag.querySelector('.lichtbak__sluit').focus();
      });
    });
  }

  /* Meer dan vier miniaturen: pijltjes om de rij te verschuiven. Ze worden hier
     neergezet en niet in Liquid, want zonder dit script schuift er niets en zou
     een pijltje een knop zijn die niets doet. */
  function miniatuurpijlen(wortel) {
    wortel.querySelectorAll('.pdp__miniaturen--schuif').forEach(function (rij) {
      if (rij.dataset.pijlen === 'ja') return;
      rij.dataset.pijlen = 'ja';

      var hoes = document.createElement('div');
      hoes.className = 'pdp__miniatuurhoes';
      rij.parentNode.insertBefore(hoes, rij);
      hoes.appendChild(rij);

      function maak(kant, teken, label) {
        var k = document.createElement('button');
        k.type = 'button';
        k.className = 'pdp__schuifknop pdp__schuifknop--' + kant;
        k.setAttribute('aria-label', label);
        k.textContent = teken;
        hoes.appendChild(k);
        return k;
      }

      var teksten = window.ncStrings || {};
      var vorige = maak('terug', '\u2190', teksten.previous || 'Vorige');
      var volgende = maak('verder', '\u2192', teksten.next || 'Volgende');

      function stap() {
        var eerste = rij.querySelector('.pdp__miniatuur');
        return eerste ? (eerste.getBoundingClientRect().width + 12) * 2 : 200;
      }

      vorige.addEventListener('click', function () { rij.scrollLeft -= stap(); });
      volgende.addEventListener('click', function () { rij.scrollLeft += stap(); });

      function stemAf() {
        // 2px speling: scrollLeft komt in browsers met een breuk terug.
        vorige.disabled = rij.scrollLeft < 2;
        volgende.disabled = rij.scrollLeft + rij.clientWidth >= rij.scrollWidth - 2;
      }
      rij.addEventListener('scroll', stemAf);
      stemAf();
    });
  }

  function init(wortel) {
    galerij(wortel);
    varianten(wortel);
    aantal(wortel);
    aanbevelingen(wortel);
    lichtbak(wortel);
    miniatuurpijlen(wortel);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
